import { Component } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { AuthService } from '@app/core/services';
import { State } from '@progress/kendo-data-query';
import { GridDataResult } from '@progress/kendo-angular-grid'; 
import { User } from '@app/core/models';


@Component({
  selector: 'page-base',
  // styleUrls: ['@overrides'],
  template: `@overrides`
})
export class PageBaseComponent {
    
  public currentUser: User = new User();

  public state: State;  

  public view: Observable<GridDataResult>;

  public loading: boolean = false;


  constructor(public authService: AuthService, protected router: Router) { 

    console.log('PageBaseComponent');
    this.authService.currentUser.subscribe(x => { 
      this.currentUser = x;
    });

  }

  public get isAdmin() {

    return JSON.stringify(this.currentUser) !== '{}'// && this.currentUser.role === Role.Admin;
  
  }

  public logout() {

    this.authService.logout();
    this.router.navigate(['/login']);

  }
    
}